import { Avatar, Box, Button, Divider, Grid, IconButton, InputAdornment, MenuItem, Pagination, Popover, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, TextField, Typography } from '@mui/material'
import React from 'react'
import { TEXT_TITLE_COLOR } from '../../constants/colors'
import { useTranslation } from 'react-i18next'
import StatusComponents from './components/statusComponent'
import { numberFormat } from '../../utils/nunberFormat'
import { convertGenderToString } from '../../utils/convertGender'
import StatusChip from '../../components/StatusChip'
import MoreHorizIcon from '@mui/icons-material/MoreHoriz';
import TableSearchNotFound from '../../components/tableSearchNotFound'
import useHrManageController from './controller'
import { DEFAULT_ROWS_PER_PAGE } from '../../config-global'
import { IMAGE_ADMIN_PROFILE } from '../../lib/endpoints/profileImage'
import LoadingAnimatedIcon from '../../components/loading/loadingAnimated'
import FormHrManageView from "./form"
import ConfirmDialog from '../../components/ConfirmDialog'
import DeleteIcon from '@mui/icons-material/Delete';
import KeyIcon from '@mui/icons-material/Key';
import EditIcon from '@mui/icons-material/Edit';
import SearchIcon from '@mui/icons-material/Search';



const HrManagePage = () => {
  const { t } = useTranslation('global')
  const controller = useHrManageController()

  const TableHeader: string[] = [
    t("admin_page.No"),
    t("admin_page.Profile"),
    t("admin_page.Full Name"),
    t("admin_page.User Name"),
    t("admin_page.Gender"),
    t("admin_page.Status"),
    ""
  ];
  return (
    <Box>
      {
        !controller?.openForm ? <>
          {
            controller?.loadingData ?
              <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                <LoadingAnimatedIcon />
              </Box> :
              <Box>

                <Box mb={3} sx={{ display: 'flex', gap: 1, justifyContent: 'space-between' }}>
                  <Box sx={{ display: 'flex', flexWrap: 'wrap', alignItems: 'center', gap: 2, width: '100%' }}>
                    <Typography variant="h4" fontWeight="bold" color={TEXT_TITLE_COLOR}>
                      {t("Mr_manage.Hr manage")}
                    </Typography>
                    <TextField
                      fullWidth
                      sx={{ maxWidth: 250 }}
                      placeholder={`${t('admin_page.Full Name')}...`}
                      value={controller.searchValue}
                      onChange={controller.handleSearch}
                      InputProps={{
                        startAdornment: (
                          <InputAdornment position="start">
                            <SearchIcon />
                          </InputAdornment>
                        ),
                      }}
                      size="small"
                    />
                  </Box>
                </Box>

                <Box sx={{ m: 1, display: 'flex' }}>
                  <Grid container spacing={2}>
                    <Grid item xs={12} sm={6} md={4}>
                      <StatusComponents
                        title={`${t("Mr_manage.All HR")}`}
                        countNumber={controller?.filterData?.length}
                        bgColor='#C4EAFF'
                      />
                    </Grid>
                  </Grid>
                </Box>

                <Box sx={{ display: 'flex', justifyContent: 'end', mt: 2, mb: 2 }}>
                  <Button
                    variant="contained"
                    color='secondary'
                    sx={{ textTransform: 'none', color: '#fff' }}
                    onClick={controller.handleOpenForm}
                  >
                    {t("Mr_manage.Create HR")}
                  </Button>
                </Box>

                <Box sx={{ mt: 1 }}>
                  <TableContainer>
                    <Table>
                      <TableHead sx={{ background: '#F4F6F8' }}>
                        <TableRow>
                          {
                            TableHeader.map((item, index) => <TableCell key={index}>{item}</TableCell>)
                          }
                        </TableRow>
                      </TableHead>
                      <TableBody>
                        {controller.rows?.map((row, index: number) => {
                          const isActive: boolean = !row?.isBan;
                          return (<TableRow key={index}>
                            <TableCell sx={{ borderBottom: 'none' }}>
                              {numberFormat(index + 1 + DEFAULT_ROWS_PER_PAGE * (controller.currentPage - 1))}
                            </TableCell>
                            <TableCell sx={{ borderBottom: 'none' }}>
                              <Avatar src={IMAGE_ADMIN_PROFILE + row?.profile?.image?.url} />
                            </TableCell>
                            <TableCell sx={{ borderBottom: 'none' }}>{row?.profile?.fullName}</TableCell>
                            <TableCell sx={{ borderBottom: 'none' }}>{row.username}</TableCell>
                            <TableCell sx={{ borderBottom: 'none' }}>{convertGenderToString(row?.profile?.gender)}</TableCell>
                            <TableCell sx={{ borderBottom: 'none' }}>
                              <StatusChip status={isActive} />
                            </TableCell>
                            <TableCell align="right" sx={{ borderBottom: 'none' }}>
                              <IconButton
                                size="large"
                                color="inherit"
                                onClick={(e: any) => controller.handleOpenMenu(e, row?.id, row?.profile?.id)}
                              >
                                <MoreHorizIcon />
                              </IconButton>
                            </TableCell>
                          </TableRow>)

                        })}
                      </TableBody>
                      {
                        controller.isSearchNotFound && (
                          <TableSearchNotFound
                            searchValue={controller.searchValue}
                            colSpan={TableHeader.length + 1}
                          />
                        )
                      }
                    </Table>
                  </TableContainer>
                  <Divider sx={{ mt: 1, mb: 1 }} />
                  <Box sx={{ display: 'flex', justifyContent: 'end' }}>
                    <Pagination
                      color="primary"
                      count={controller.countPagination}
                      page={controller.currentPage}
                      onChange={controller.handleChangePage}
                    />
                  </Box>
                </Box>
                <Popover
                  open={Boolean(controller.openMenu)}
                  anchorEl={controller.openMenu}
                  onClose={controller.handleCloseMenu}
                  anchorOrigin={{ vertical: 'top', horizontal: 'left' }}
                  transformOrigin={{ vertical: 'top', horizontal: 'right' }}
                  PaperProps={{
                    sx: {
                      p: 1,
                      width: 150,
                      '& .MuiMenuItem-root': {
                        px: 1,
                        typography: 'body2',
                        borderRadius: 0.75,
                      },
                    },
                  }}
                >
                  <MenuItem onClick={() => controller.handleOpenEditForm()}>
                    <EditIcon />
                    &nbsp;&nbsp; {t("Edit")}
                  </MenuItem>
                  {/* <MenuItem onClick={() => controller.handleOpenChangePasswordForm()}>
                    <KeyIcon />
                    &nbsp;&nbsp;{t("Change password")}
                  </MenuItem> */}
                  <MenuItem sx={{ color: 'error.main' }} onClick={() => controller.handleOpenDeleteForm()}>
                    <DeleteIcon />
                    &nbsp;&nbsp; {t("Delete")}
                  </MenuItem>
                </Popover>
                <ConfirmDialog
                  open={controller.openDeleteForm}
                  title='Do you want to delete this HR'
                  loading={controller.loadingDeleteButton}
                  onCancel={controller.handleCloseDeleteForm}
                  onConfirm={() => controller.handleDeleteAdminData()}
                />
              </Box>
          }
        </> :
          <FormHrManageView onClose={controller.handleCloseForm} roleValue={controller.roleValue} onFetchData={controller.handleGetData} selectData={controller.selectData} />
      }

    </Box>
  )
}

export default HrManagePage